module.exports = __webpack_public_path__ + "static/media/ic_gold_added.dccd1d0f.svg";